module.exports = __webpack_public_path__ + "assets/img/20_156_big.c6cc7d01.jpg";